import { useSyncExternalStore } from "react";
import type { PremiumFeatureKey } from "./premium";
import type { UpsellTrigger } from "./events";

/**
 * App-wide "show the Premium upsell" requests, for surfaces that don't own
 * an overlay of their own (top-bar Invite, the onboarding coach bar, the
 * share sheet). `GlobalUpsell` in `App.tsx` renders whatever is requested.
 */
export interface UpsellRequest {
  feature: PremiumFeatureKey;
  trigger: UpsellTrigger;
}

let current: UpsellRequest | null = null;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function requestUpsell(feature: PremiumFeatureKey, trigger: UpsellTrigger): void {
  current = { feature, trigger };
  emit();
}

export function getUpsellRequest(): UpsellRequest | null {
  return current;
}

export function closeUpsellRequest(): void {
  if (!current) return;
  current = null;
  emit();
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function useUpsellRequest(): UpsellRequest | null {
  return useSyncExternalStore(subscribe, () => current, () => null);
}
